module.exports = __webpack_public_path__ + "downloads/Data.12a9ddd8.xlsx";